import React from 'react';

const TM = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_27"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_27)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#2DB771"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H3V15H2V0ZM4 0H5V15H4V0ZM6 0H7V15H6V0Z"
        fill="#D4B339"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0L7 1.5L5 3V0ZM5 3L7 4.5L5 6V3ZM5 6L7 7.5L5 9V6ZM5 9L7 10.5L5 12V9ZM5 12L7 13.5L5 15V12ZM4 0L2 1.5L4 3V0ZM4 3L2 4.5L4 6V3ZM4 6L2 7.5L4 9V6ZM4 9L2 10.5L4 12V9ZM4 12L2 13.5L4 15V12ZM4 0H5V2H4V0ZM4 13H5V15H4V13ZM4 5H5V7H4V5ZM4 3H5V4H4V3ZM4 11H5V12H4V11ZM4 8H5V10H4V8Z"
        fill="#AE6A3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.236 3.014C11.323 3.004 11.411 3 11.5 3C12.88 3 14 4.12 14 5.5C14 6.88 12.88 8 11.5 8C10.12 8 9 6.88 9 5.5C9 5.41 9.005 5.323 9.014 5.236C9.13 6.23 9.974 7 11 7C12.105 7 13 6.105 13 5C13 3.975 12.23 3.13 11.236 3.014ZM10 4H11V5H10V4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4H9V5H8V4ZM10 2H11V3H10V2Z"
        fill="#9EE2C0"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default TM;
